import configureStore from "./configureStore";

export const persistConfigStorage = {
  whitelist: ["app", "user", "project"],
  blacklist: ["isSuccess"],
};
export const initialStoreCongig = configureStore({});
export const store = initialStoreCongig.store;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
